import React from "react";

import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { IconButton, Stack, Typography } from "@mui/material";
import { useDevice, useModals, useNavigate } from "hooks";

import { FreemiumMessages } from "../../../constants";
import { BenchmarkTable } from "./BenchmarkTable";

export const Benchmark: React.FC = () => {
  const navigate = useNavigate();
  const { infoModal } = useModals();
  const { isMobile } = useDevice();

  const handleOpenInNew = () => {
    isMobile &&
      infoModal({
        title: FreemiumMessages.BEST_PRACTICE_RECOMMENDATION_TITLE,
        msg: FreemiumMessages.BEST_PRACTICE_RECOMMENDATION_MESSAGE,
        buttonText: "Continue"
      });
    navigate({ route: "benchmarkPerformance" });
  };

  return (
    <Stack
      sx={{
        width: "100%",
        p: "16px",
        gap: "16px",
        bgcolor: "white",
        borderRadius: "8px",
        boxShadow: "0px 1px 2px 0px rgba(18, 18, 23, 0.1)"
      }}
      alignItems="stretch"
      direction="column"
    >
      {/* Header */}
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Stack direction="row" alignItems="center" gap="10px">
          <Typography sx={{ fontSize: "18px", fontWeight: 500, color: "#071f35" }}>Benchmark</Typography>
          <IconButton sx={{ width: "20px", height: "20px", padding: 0 }} onClick={handleOpenInNew}>
            <OpenInNewIcon sx={{ width: "16px", height: "16px", color: "#071F35" }} />
          </IconButton>
        </Stack>
      </Stack>

      {/* Table Content */}
      <BenchmarkTable currency="USD" />
    </Stack>
  );
};
